import { actionCreators as FeedItemsActions } from '@app/components/FeedItem/modules/feedItems'
import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import ActivityFeed from '../components/ActivityFeed'
import {
  actionCreators,
  IActivityFeedState,
  selectEntityId,
  selectError,
  selectFilter,
  selectIsLoading,
  selectIsLoadingNewItems,
  selectItemChangedIndex,
  selectItems,
  selectNewItems,
  selectScope,
  selectTotalItems,
} from '../modules/activityFeed'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IActivityFeedState & ICurrentUserState
  >({
    entityId: selectEntityId(),
    error: selectError(),
    filterText: selectFilter(),
    isLoading: selectIsLoading(),
    isLoadingNewItems: selectIsLoadingNewItems(),
    itemChangedIndex: selectItemChangedIndex(),
    items: selectItems(),
    newItems: selectNewItems(),
    scope: selectScope(),
    totalItems: selectTotalItems(),
    user: selectCurrentUser(),
  }),
  Object.assign({}, actionCreators, {
    clearFeedItems: FeedItemsActions.clearFeedItems,
  }),
)(ActivityFeed)
